<template>
  <div id="headnav">
    <div class="head-nav flex bCenter">
      <div class="head-nav-list flex middle">
        <span class="head-logo"><img :src="image_logo" alt=""></span>
        <ul class="flex">
          <template v-for="(item,index) in navList">
            <router-link
              tag="li"
              :to="{path:getPath(item),query:{menuid:item.menuid,jumpUrl:item.jumpUrl}}"
              :key="index"
              :class="{'is-active':isActiveC(item)}"
            >
              <span class="nav-text">{{item.name}}</span>
            </router-link>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex'
import {headNavData,personalCenterMenu} from './headNavData.js';
import menuConfig from "config/me_menu.config.js";

export default {
  name:'headnav',
  computed: {
      ...mapGetters(['headMenuTree','isJudges','isShowAppStore','noticeTotal']),
      isActiveC(){
        return (item)=>{
          if(this.$utils.isNoNullAll(this.$route.path)&&this.$route.path!="/"&&this.$utils.isNoNullAll(item.jumpUrl)&&new RegExp("^"+item.jumpUrl+".*$").test(this.$route.path)){
            return true;
          }
          return false;
        }
      }
  },
  data(){
    return {
      //图片
      image_logo:require("assets/images/logo.png"),
      navList:[], //导航数据
      isActive:0
    }
  },
  created(){
    this.navList=headNavData;
    this.$store.state.app.menuList=menuConfig.menu;
    // this.navList=[...this.headMenuTree];
  },
  methods:{
    getPath(item){//得到路由地址
      if(item.isOutLink == 1){//外部地址
        return "/out-link-view";
      }else{
        return item.jumpUrl;
      }
    }
  },
  watch:{
    '$store.state.user.userInfo':{
      handler(newVal,oldVal){
        this.userInfo = newVal;
        this.isUserInfoEmpty();
      },
      deep:true,
      immidate:true,
    }
  },
}
</script>

<style lang="less" scoped>
  #headnav{
    width: 100%;
    height: 60px;
    box-shadow: 5px 0 5px #ccc;
    background-color: #242B33;
    display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    .head-nav{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      align-items: flex-end;
      .head-nav-list{
        align-items: flex-end;
        .head-logo{
          font-size: 22px;
          white-space: nowrap;
          font-weight: bold;
          line-height: 76px;
          height: 70px;
          background-image:-webkit-linear-gradient(98deg,rgba(0,191,49,1) 0%,rgba(63,140,255,1) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color:transparent;
          margin-right: 32px;
          box-sizing: border-box;
          // padding-bottom: 12px;
          img{
            width: 236px;
            position: relative;
            vertical-align: middle;
            left: 0;
            bottom: 0;
          }
        }
        .head-logo2{
          background-image:linear-gradient(98deg,rgba(235,21,8,1) 0%,rgba(255,225,83,1) 100%);
        }
        ul{
          li{
            font-size: 18px;
            text-align: center;
            cursor: pointer;
            vertical-align: bottom;
            padding: 0 15px;
            .nav-text{
              white-space: nowrap;
              display: inline-block;
              outline: none;
              font-size: 18px;
              height: 60px;
              line-height: 60px;
            }
          }
           .is-active{
            background-color: #12171D;
            .nav-text{
              color: #25AE5E;
            }
          }
        }
      }
      .notice{
        cursor: pointer;
        position: relative;
        img{
          width:30px;
          height: 30px;
        }
        .numbers{
          z-index: 1000;
          position: absolute;
          top:-6px;
          right:-6px;
          width:20px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
            background: #FF3A3A;
            color: #fff;
            border-radius: 50%;
          p{

            font-size: 12px;
            
          }
        }
      }
      .head-nav-btn{
        box-sizing: border-box;
        padding-bottom: 14px;
        .btn{
          background: red;
          border-color: red;
        }
      }
      .head-nav-btn-out{
        align-items: flex-end;
        span{
          font-size: 18px;
          // margin-right: 20px;
          max-width: 152px;
          // display: inline-block;
        }
      }
    }

    .userCenter{
      display: flex !important;
      cursor: pointer;
      .name_kuang{
        display: flex;
      }
      .name{
        max-width: 100px!important;
        // min-width: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline!important;
        margin-right: 14px!important;
      }
      .arrow-bottom{
        color: #666666;
        vertical-align: middle;
        margin-top: 3px;
      }
    }
  }
</style>


